import React from "react";
import { connect } from "react-redux";
import { NumberInput } from "@revvsales/components";
import { RevvForm /* ErrorMessages */ } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";
import {
  CURRENCY_SYMBOL,
  DEFAULT_CURRENCY,
} from "../../../../constants/common";
import { numberForamting } from "../../../../utils/globalUtils";

class AmountFieldFormMode extends React.Component {
  state = {
    amountfieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value) || value === "") {
      const { id, meta } = this.props.initialProps;
      let prefix = "";
      if (value !== "") {
        prefix = numberForamting(value, CURRENCY_SYMBOL[meta.currency]);
      }
      this.props._updateDynamicFieldsInDoc(
        id,
        value !== "" ? value : null,
        prefix,
      );
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else {
        this.props.filledStatus(false);
      }
    }
  };

  getCurrencySymbol = meta => {
    let currencyInfo = this.props.priceBook
      ? this.props.priceBook.currency
      : DEFAULT_CURRENCY;

    if (
      Object.keys(meta).length !== 0 &&
      meta.currency &&
      meta.currency !== "PRICEBOOK"
    ) {
      currencyInfo = meta.currency;
    }
    const symbol = CURRENCY_SYMBOL[currencyInfo];
    return symbol;
  };

  render() {
    const {
      id,
      label,
      placeholder,
      meta,
      /* docIsLocked */
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.amountfieldValues}
          customFieldName="AMOUNT"
          customFieldComponentRules={CustomFieldComponentRules}
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const {
              handleChangeByName,
              handleBlur,
              messages,
              values,
            } = formProps;
            return (
              <React.Fragment>
                <NumberInput
                  id={id}
                  name="default"
                  type="number"
                  isCurrency
                  className="form-mode-input"
                  // {`form-mode-input ${
                  //   messages.default && messages.default.required !== ""
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  inpCurrencySymbol={this.getCurrencySymbol(meta)}
                  placeholder={`${placeholder || `Enter ${label}`}`}
                  isFloat
                  onChange={event => handleChangeByName(event, "default")}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values.default}
                  disabled={this.props.isLocked}
                  data-test="amount-field-form-mode"
                  autoFocus
                />
                {/**
                  <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.required} />
                  )}
                </div>
                 */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { dealTableId } = state.QuotationStore;
  const {
    priceBook: { [dealTableId]: priceBook = {} } = {},
  } = state.DealTableStore;
  return { priceBook };
};

export default connect(
  mapStateToProps,
  null,
)(AmountFieldFormMode);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/AmountFieldFormMode.js